import styled from 'styled-components'
import { PRIMARY_COLOR } from '../../../../styles/colors.style'
import Button from '../../../../components/buttons/buttons.component'

export const MainContainer = styled('div')`
	display: flex;
	flex: 1;
	flex-direction: column;
	padding: 10px;
`

export const Title = styled('span')`
	font-size: 36px;
	font-weight: 100;
	margin-bottom: 35px;
`

export const SubTitle = styled('span')`
	margin-bottom: 20px;
`

export const Question = styled('span')`
	margin-bottom: 20px;
	font-weight: bold;
`

export const FooterContainer = styled('div')`
	display: flex;
	flex: 1;
	flex-direction: row;
	justify-content: end;
`

export const ConfirmationButton = styled(Button)`
	padding: 20px;
	border: none;
	background-color: ${PRIMARY_COLOR};
	border-radius: 5px;
	margin-right: 10px;
	color: #fff;
	width: 100px;
`

export const DenyButton = styled(Button)`
	padding: 20px;
	border: none;
	color: ${PRIMARY_COLOR};
	width: 100px;
`
